import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

export const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    const redirigirAlLogin = async () => {
      await auth.removeUser();
      globalThis.location.replace('/login');
    };

    auth.events.addAccessTokenExpired(redirigirAlLogin);
    globalThis.addEventListener('auth:sesion-expirada', redirigirAlLogin);

    return () => {
      auth.events.removeAccessTokenExpired(redirigirAlLogin);
      globalThis.removeEventListener('auth:sesion-expirada', redirigirAlLogin);
    };
  }, [auth]);

  return <>{children}</>;
};
